import { css } from 'styled-components';
import { HTML_ROOT_DRAG_ACTIVE_CLASS } from 'components/SortableStack';
function baseStyles(_ref) {
  var theme = _ref.theme;
  var text = theme.text,
    background = theme.background,
    globals = theme.globals;
  return css(["html{color:", ";background-color:", ";font:400 ", "px / ", " 'Open Sans',sans-serif;-webkit-text-size-adjust:100%;-ms-text-size-adjust:100%;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;cursor:default;}html[", "='true']{pointer-events:none;}@media print{#app[aria-hidden='true']{display:none;}}"], text, background, globals.fontSize, globals.lineHeight, HTML_ROOT_DRAG_ACTIVE_CLASS);
}
export default baseStyles;